var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:['svgicon',{'svgicon--pointer':_vm.pointer}],style:({fontSize:_vm.size+'px', '--color': _vm.color}),attrs:{"fill":_vm.color,"aria-hidden":"true"},on:{"click":_vm.trigger,"mouseover":_vm.svgover,"mouseout":_vm.svgout}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79480bbe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","audio":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/SvgIcon.vue
// module id = null
// module chunks = 